import { BaseAPI } from "@/api/baseAPI";
import type { Cause } from "@/types";

class CauseAPI extends BaseAPI<Cause> {
  constructor() {
    super("cause");
  }

  
}

export default new CauseAPI();
